export const rateBrowserWhitelistKeys = {
  properties: true, // not on swagger
  shipFrom: true, // not on swagger
  packingSlipTemplateId: true, // not on swagger
  shipmentEmailNotificationTemplateId: true, // not on swagger
  deliveryEmailNotificationTemplateId: true, // not on swagger
  items: true, // not on swagger
  calculateInsuranceValue: true, // not on swagger
  rate: true, // not on swagger
  shippingConfigurationHash: true, // <-- not on swagger
  carrierId: true, // <-- not on swagger
};

export const rateBrowserFalsyChecksOk = (key, contextValue, reduxValue) => {
  const nullIsOkForUndefined = {
    shipDate: true,
    driverTip: true,
    serviceCollectionGuid: true,
  };
  if (nullIsOkForUndefined[key] && contextValue === null && reduxValue === undefined) {
    return true;
  }

  if (key === 'email' && !contextValue && !reduxValue) {
    return true;
  }
  return false;
};
